import { prettyFloat } from 'webui/utils/number';
export function getGsmLevel(gsm_state) {
    if (gsm_state) {
        if (gsm_state.state !== 'not-registered' && gsm_state.level) {
            const percent = Number(prettyFloat((gsm_state.level / 31) * 100, 0));
            return {
                gsm_percent: percent > 100 ? 0 : percent,
                gsm_bars: ~~(gsm_state?.level / 8 + 1),
            };
        }
        if (gsm_state.level) {
            return {
                gsm_percent: 0,
                gsm_bars: 0,
            };
        }
    }
    return { gsm_percent: null, gsm_bars: null };
}
export function gsmTitle(online, gsm_percent, is_4g) {
    if (!online) {
        return `Нет связи с устройством`;
    }
    if (gsm_percent != null && gsm_percent != 0) {
        return `Есть сигнал ${is_4g ? '4G(LTE)' : 'GSM'}`;
    }
    return `Нет сигнала ${is_4g ? '4G(LTE)' : 'GSM'}`;
}
export function radioSilenceText(radiosilence_planned, radiosilence) {
    if (radiosilence_planned === true) {
        return 'запланировано включение';
    }
    if (radiosilence_planned === false) {
        return 'запланировано выключение';
    }
    if (radiosilence === true) {
        return 'включено';
    }
    if (radiosilence === false) {
        return 'выключено';
    }
    return '';
}
